module.exports = __webpack_public_path__ + "static/Toddlers-0af70db16516a3b8a52dbdbccb76c74e.png";